import storageAvailable from '../../../helpers/storage_available';
// get the stored search location, check for resumed search and if so replace the current location with the stored location. Finally delete the stored search and return the new search data
export default function(initialSearchData) {
  if (storageAvailable('sessionStorage')) {
    const storedSearch = sessionStorage.getItem('resume_map_search');
    if (storedSearch && initialSearchData.api_params.resume_search) {
      const { location } = JSON.parse(storedSearch);
      if (location) {
        initialSearchData.location_info = location;
      }
    } else if (initialSearchData.api_params.resume_search) {
      initialSearchData.api_params.resume_search = 0;
    }
    const url = new URL(document.location);
    url.searchParams.delete('resume_last_search');
    window.history.replaceState({}, document.title, url.pathname + url.search);
    sessionStorage.removeItem('resume_map_search');
  }
  return initialSearchData;
}
